import { Component, Injector, Input } from '@angular/core';
import { TableDummiesWidgetBaseComponent } from '../table-dummies-widget-base/table-dummies-widget-base';

/**
 * TableDummies4Half Widget
 */
@Component({
  selector: 'table-dummies4-half-widget',
  templateUrl: './table-dummies4-half-widget.component.html',
  styleUrls: ['../../common/css/general.scss', '../table-dummies-widget-base/table-dummies-widget-base.scss']
})
export class TableDummies4HalfWidgetComponent extends TableDummiesWidgetBaseComponent {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'tableDummies4Half');
  }
}
